import { render, staticRenderFns } from "./DateCardPicker.vue?vue&type=template&id=5734d966&"
import script from "./DateCardPicker.vue?vue&type=script&lang=js&"
export * from "./DateCardPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports